import React from 'react';
import { CLASH_AUGMENT_OPTIONS, getAugmentDisplaySvg, getClashAugmentOption } from '../../utils/augments';
import { formatClashLeagueDisplay } from '../../utils/clashDisplay';
import { getClashAugmentCodeOnGame } from './clashBettingUtils';
import './ClashUI.css';

function augmentShortLabel(code) {
  if (!code) return null;
  return CLASH_AUGMENT_OPTIONS.find((o) => o.value === code)?.label ?? code;
}

/**
 * Read-only opponent pill (e.g. Private Leagues weekly clash line).
 */
export function ClashOpponentPill({ opponentUsername, subtitle, title }) {
  if (!opponentUsername) return null;
  return (
    <span className="clash-chip clash-chip--readonly" title={title}>
      <span className="clash-chip__vs">vs</span>
      <span className="clash-chip__name">{opponentUsername}</span>
      {subtitle ? <span className="clash-chip__hint">{subtitle}</span> : null}
    </span>
  );
}

/**
 * Per-match row: clash opponents for the round with placement vs this `gameId`.
 */
export function ClashOpponentChips({
  clashTargets,
  bets,
  gameId,
  disabled,
  inventory,
  onOpenTarget
}) {
  const gid = String(gameId);
  if (!clashTargets?.length) return null;

  return (
    <div className="clash-augment-row clash-chips-wrap">
      <div className="clash-chips-row">
        <span className="clash-chips-label">Clash this week</span>
        {clashTargets.map((t) => {
          const codeHere = getClashAugmentCodeOnGame(bets, gid, t.augmentMapKey);
          const onHere = codeHere != null;
          const augLabel = onHere ? augmentShortLabel(codeHere) : null;

          const clashDef = codeHere ? getClashAugmentOption(codeHere) : null;
          const clashDisplaySvg =
            codeHere && clashDef
              ? getAugmentDisplaySvg(codeHere, inventory) ?? clashDef.svg
              : null;
          const chipClass =
            'clash-chip clash-chip--interactive' +
            (onHere && augLabel ? ' clash-chip--here' : '') +
            (codeHere ? ` clash-chip--clash-${codeHere}` : '');

          const { label: clashLeagueLabel } = formatClashLeagueDisplay(t.leagueName, t.leagueId);

          return (
            <button
              key={t.augmentMapKey}
              type="button"
              className={chipClass}
              disabled={disabled}
              onClick={() => onOpenTarget?.(t)}
              title={
                clashLeagueLabel
                  ? `${clashLeagueLabel}: clash vs ${t.opponentUsername} — click to choose plays for this match`
                  : `Clash vs ${t.opponentUsername} — click to choose plays for this match`
              }
            >
              <span className="clash-chip__vs">vs</span>
              <span className="clash-chip__name">{t.opponentUsername}</span>
              {augLabel ? (
                <span className="clash-chip__augment">
                  {clashDisplaySvg ? (
                    <img src={clashDisplaySvg} alt="" className="clash-chip__augment-icon" width={18} height={18} aria-hidden />
                  ) : null}
                  <span className="clash-chip__augment-label">{augLabel}</span>
                </span>
              ) : null}
            </button>
          );
        })}
      </div>
    </div>
  );
}
